import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Label} from '@/components/ui/label/Label'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {StyledPlannedAccessFrequencyCounter} from '@/features/planned-accesses/components/accesses-form/planned-accesses-frequency-counter/style'
import {PlannedAccessesFieldsSchema} from '@/features/planned-accesses/formSchemas'
import {calculateTotalAccesses} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'
import {useMemo} from 'react'
import {useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

const PlannedAccessesFrequencyCounterSchema = PlannedAccessesFieldsSchema.pick({
    inPersonAccesses: true
})
type PlannedAccessesFrequencyCounterSchema = z.infer<typeof PlannedAccessesFrequencyCounterSchema>

export const PlannedAccessesFrequencyCounter = ({
    isLoading,
    duration,
    index
}: {
    isLoading: boolean
    duration: number
    index: number
}) => {
    const {t} = useTranslation()
    const {control} = useFormContext<PlannedAccessesFrequencyCounterSchema>()
    const frequency = useWatch({control, name: `inPersonAccesses.${index}.frequency`})
    const numberOfAccesses = useWatch({control, name: `inPersonAccesses.${index}.numberOfAccesses`})

    const total = useMemo(() => {
        if ((frequency == 'weekly' || frequency == 'monthly') && numberOfAccesses) {
            return calculateTotalAccesses(duration, frequency, numberOfAccesses)
        }

        return 0
    }, [duration, frequency, numberOfAccesses])

    return (
        <Flexbox direction="column" gap={1.5} align="center" justify="center">
            <Label>{t('planned_accesses:total_accesses')}</Label>
            {isLoading ? (
                <Skeleton width="100%" height={20} />
            ) : (
                <StyledPlannedAccessFrequencyCounter>{total ?? '-'}</StyledPlannedAccessFrequencyCounter>
            )}
        </Flexbox>
    )
}
